/**
 * User organisation context (cache-safe personalisation)
 *
 * Fetches the current user's org relationship once, then:
 *   - reveals elements matching data-org-state
 *   - fills links/text via data-org-href / data-org-text
 *
 * Usage:
 *
 *   <div class="js-user-org-context" data-ajax-url="/wp-admin/admin-ajax.php">
 *     <p class="js-user-org-state" data-org-state="guest" style="display:none">…</p>
 *     <p class="js-user-org-state" data-org-state="member" style="display:none">…</p>
 *     <p class="js-user-org-state" data-org-state="manager_single" style="display:none">
 *       <a data-org-href="edit_url" href="#">Edit <span data-org-text="org_title"></span></a>
 *     </p>
 *     <p class="js-user-org-state" data-org-state="manager_multiple" style="display:none">
 *       <a data-org-href="profile" href="#">Your profile</a>
 *     </p>
 *   </div>
 *
 * data-org-href values:
 *   edit_url | members_url | profile | join | join_form | join_organisation | login | url
 *
 * data-org-text values:
 *   org_title
 */
(function () {
	var containers = document.querySelectorAll('.js-user-org-context');
	if (!containers.length) return;

	var ajaxUrl = containers[0].getAttribute('data-ajax-url');
	if (!ajaxUrl) return;

	var data = new FormData();
	data.append('action', 'cee_user_org_context');

	fetch(ajaxUrl, {
		method: 'POST',
		credentials: 'same-origin',
		body: data,
	})
		.then(function (r) {
			return r.json();
		})
		.then(function (res) {
			if (!res.success || !res.data) return;
			applyContext(res.data);
		})
		.catch(function () {
			// Silently fail — states stay hidden
		});

	function firstManaged(ctx) {
		return (ctx.managed_orgs && ctx.managed_orgs[0]) || null;
	}

	// Prefer managed org; fall back to first membership (e.g. member → edit shows no-permissions).
	function firstOrg(ctx) {
		return firstManaged(ctx) || (ctx.member_orgs && ctx.member_orgs[0]) || null;
	}

	function resolveHref(key, ctx) {
		var org = firstOrg(ctx);
		var urls = ctx.urls || {};

		switch (key) {
			case 'edit_url':
				return org ? org.edit_url : '';
			case 'members_url':
				return org ? org.members_url : '';
			case 'url':
				return org ? org.url : '';
			case 'profile':
			case 'join':
			case 'join_form':
			case 'join_organisation':
			case 'login':
				return urls[key] || '';
			default:
				return urls[key] || '';
		}
	}

	function resolveText(key, ctx) {
		var org = firstOrg(ctx);
		if (key === 'org_title') {
			return org ? org.title : '';
		}
		return '';
	}

	function fillDynamicFields(root, ctx) {
		root.querySelectorAll('[data-org-href]').forEach(function (el) {
			var href = resolveHref(el.getAttribute('data-org-href'), ctx);
			if (href) {
				el.setAttribute('href', href);
			}
		});

		root.querySelectorAll('[data-org-text]').forEach(function (el) {
			var text = resolveText(el.getAttribute('data-org-text'), ctx);
			if (text) {
				el.textContent = text;
			}
		});
	}

	function applyContext(ctx) {
		var state = ctx.state || 'guest';

		containers.forEach(function (container) {
			fillDynamicFields(container, ctx);

			container.querySelectorAll('.js-user-org-state').forEach(function (el) {
				if (el.getAttribute('data-org-state') === state) {
					el.style.display = '';
				} else {
					el.style.display = 'none';
				}
			});

			container.setAttribute('data-resolved-state', state);
			container.classList.add('is-resolved');
		});
	}
})();
